import { gql } from "@apollo/client"

export const GET_TOURNAMENTS = gql`
  query GetTournaments(
    $filter: TournamentFilter
    $orderBy: TournamentOrderBy
    $page: Int
    $paginate: Int
  ) {
    tournaments(filter: $filter, orderBy: $orderBy, page: $page, paginate: $paginate) {
      id
      name
      uid
      description
      image
      eventUrl
      storeId
      gameId
      addressId
      seasonId
      statusId
      typeId
      formatId
      maxPlayers
      rounds
      rankingValid
      startDate
      endDate
      processedDate
      Store {
        id
        name
        description
        phone
        email
        website
        logo
        banner
        active
        verified
        Address {
          id
          name
          address
          lattitude
          longitude
          Country {
            id
            name
            iso
          }
          Region {
            id
            name
            alias
          }
          Location {
            id
            name
          }
        }
      }
      Game {
        id
        name
        description
        image
        website
        urlImage
        urlIcon
      }
      Season {
        id
        name
        description
        startDate
        endDate
        status
        active
      }
      Format {
        id
        name
        description
        image
        status
      }
      Address {
        id
        name
        address
        lattitude
        longitude
        Country {
          id
          name
          iso
        }
        Region {
          id
          name
          alias
        }
        Location {
          id
          name
        }
      }
    }
  }
`

export const GET_TOURNAMENT_BY_ID = gql`
  query GetTournamentById($id: Int!) {
    tournament(id: $id) {
      id
      name
      uid
      description
      image
      eventUrl
      storeId
      gameId
      addressId
      seasonId
      statusId
      typeId
      formatId
      maxPlayers
      rounds
      rankingValid
      startDate
      endDate
      processedDate
      Store {
        id
        name
        description
        phone
        email
        website
        logo
        banner
        active
        verified
        Address {
          id
          name
          address
          lattitude
          longitude
          Country {
            id
            name
            iso
          }
          Region {
            id
            name
            alias
          }
          Location {
            id
            name
          }
        }
      }
      Game {
        id
        name
        description
        image
        website
        rules
        urlImage
        urlIcon
        urlActiveSeason
      }
      Season {
        id
        name
        description
        startDate
        endDate
        status
        active
        Game {
          id
          name
          image
        }
      }
      Format {
        id
        name
        description
        image
        status
        deckbuilder
        maxCopies
        minDeck
        maxDeck
      }
      Address {
        id
        name
        address
        lattitude
        longitude
        Country {
          id
          name
          iso
        }
        Region {
          id
          name
          alias
        }
        Location {
          id
          name
        }
      }
    }
  }
`

export const GET_TOURNAMENT_RANKINGS = gql`
  query GetTournamentRankings($tournamentId: Int!, $seasonId: Int, $page: Int, $paginate: Int) {
    tournamentRankings(
      tournamentId: $tournamentId
      seasonId: $seasonId
      page: $page
      paginate: $paginate
    ) {
      position
      points
      player {
        id
        name
        nickname
        avatar
        email
      }
      tournament {
        id
        name
        startDate
        endDate
      }
      season {
        id
        name
        startDate
        endDate
      }
    }
  }
`
